var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 363.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-8{fill:#ebebeb;}.cls-1{opacity:0.45;}.cls-14,.cls-2,.cls-22{opacity:0.2;}.cls-3{opacity:0.36;}.cls-4{fill:#f4f4f4;}.cls-5{fill:#e6e6e6;}.cls-15,.cls-19,.cls-22,.cls-23,.cls-6,.cls-9{fill:#fff;}.cls-7{fill:#ededed;}.cls-8{opacity:0.48;}.cls-9{opacity:0.14;}.cls-10{fill:#407bff;}.cls-11{fill:#e4897b;}.cls-12{fill:#2e353a;}.cls-13,.cls-18,.cls-21{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-13{stroke:#577afa;stroke-width:0.48px;}.cls-14,.cls-15,.cls-16,.cls-19,.cls-20,.cls-22,.cls-23,.cls-24{isolation:isolate;}.cls-15{opacity:0.6;}.cls-16{opacity:0.3;}.cls-17{fill:#de5753;}.cls-18,.cls-21{stroke:#2e353a;}.cls-18{stroke-width:0.72px;}.cls-19,.cls-24{opacity:0.8;}.cls-20{opacity:0.4;}.cls-21{stroke-width:0.5px;}.cls-23{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 416.78,
    y: 334.9,
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 322.53,
    y: 337.61,
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 396.59,
    y: 325.61,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.46,
    y: 327.29,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.56,
    y: 327.29,
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 131.47,
    y: 331.51,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "405.66 319.05 405.66 159.8 403.31 159.8 403.31 159.3 402.45 159.3 402.45 136.3 397.7 136.3 397.7 130.3 386.7 130.3 386.7 109.8 380.68 109.8 380.68 95.3 373.28 95.3 373.28 74.18 370.63 74.18 370.63 95.3 363.23 95.3 363.23 109.8 357.2 109.8 357.2 130.3 346.2 130.3 346.2 136.3 341.45 136.3 341.45 159.8 339.84 159.8 339.84 127.05 337.19 127.05 337.19 148.05 334.24 148.05 334.24 98.05 331.59 98.05 331.59 119.05 324.19 119.05 324.19 111.3 320.69 111.3 320.69 82.8 318.59 82.8 318.59 82.3 315.09 82.3 315.09 53.8 312.59 53.8 312.59 58 271.55 58 271.55 45.25 264.55 45.25 264.55 0 261.8 0 261.8 45.25 252.05 45.25 252.05 58 247.55 58 247.55 118 226.55 118 226.55 100 234.05 100 234.05 96.5 226.55 96.5 226.55 92 206.55 92 206.55 46 201.55 46 201.55 39 178.05 39 178.05 46 174.55 46 174.55 109.5 163.55 109.5 163.55 139 157.92 139 157.92 115.5 153.17 115.5 153.17 109.5 142.17 109.5 142.17 89 136.14 89 136.14 74.5 128.74 74.5 128.74 53.38 126.1 53.38 126.1 74.5 118.69 74.5 118.69 89 112.67 89 112.67 109.5 101.67 109.5 101.67 115.5 96.92 115.5 96.92 139 94.34 139 94.34 319.05 405.66 319.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.86,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 282.36,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.86,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.36,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.86,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264.36,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.86,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.36,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 60.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 65.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 70.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 75.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 79.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 84.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 89.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 94.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.86,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.19,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.69,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.19,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 186.69,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 91.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.19,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 48.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 53.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 57.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 91.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.69,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 106.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 111.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 135.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 140.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 136.86,
    y: 144.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 106.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 111.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.36,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 106.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 111.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.86,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 106.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 111.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 125.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 130.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 135.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.36,
    y: 140.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 106.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 111.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 125.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 130.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 135.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 140.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 144.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 159.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.86,
    y: 163.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 92.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 97.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 102.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 116.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 121.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 125.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 130.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 135.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 140.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 144.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 159.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 163.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.36,
    y: 168.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 151.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 184.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 189.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 375.36,
    y: 203.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 151.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 370.86,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 98.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 103.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 108.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 113.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 117.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 151.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.36,
    y: 203.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 133.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 138.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 142.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 147.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 152.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 157.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 161.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 166.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 171.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 176.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 180.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 185.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 190.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 392.19,
    y: 199.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 133.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 138.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 142.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 147.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 152.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 157.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 161.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 166.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 171.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 176.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 180.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 185.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 190.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 387.69,
    y: 199.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 133.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 138.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 142.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 147.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 152.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 157.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 161.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 166.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 171.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 176.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 180.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 185.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 190.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 195.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.19,
    y: 199.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 134.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 139.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 144.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 149.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 153.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 158.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 163.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 168.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 172.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 177.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 191.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 196.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 201.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 206.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 210.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.19,
    y: 215.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 134.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 139.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 144.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 149.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 153.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 158.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 163.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 168.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 172.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 187.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 191.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 196.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 201.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 206.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 210.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 215.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 220.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 225.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 229.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 234.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.69,
    y: 239.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 134.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 139.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 144.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 149.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 153.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 158.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 163.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 168.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 182.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 187.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 191.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 196.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 201.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 206.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.19,
    y: 210.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 91.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 138.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 152.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 157.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 162.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.36,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 91.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 162.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.86,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 62.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 67.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 72.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 76.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 81.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 86.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 91.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 152.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 157.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.36,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 151.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 184.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 189.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 193.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 208.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 212.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 217.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 323.69,
    y: 222.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 184.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 189.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 193.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 198.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 212.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.19,
    y: 217.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 122.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 127.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 132.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 136.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 141.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 146.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 155.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 160.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 165.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 170.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 174.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 179.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 184.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 189.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 193.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 198.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.69,
    y: 203.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 138.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 152.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 162.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 171.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 176.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 186.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 190.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 195.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.86,
    y: 200.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 138.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 152.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 171.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 181.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 186.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 190.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 195.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.36,
    y: 200.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 95.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 100.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 105.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 110.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 114.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 119.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 124.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 129.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 133.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 138.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 143.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 148.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 152.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 157.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 167.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 176.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 181.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 186.22,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 190.97,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 195.72,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.86,
    y: 200.47,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 123.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 127.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 132.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 137.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 142.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 146.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 161.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 165.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 170.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 175.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 180.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 184.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 189.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 199.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 203.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 208.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 213.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.19,
    y: 227.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 123.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 127.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 132.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 137.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 142.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 146.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 161.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 165.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 170.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 175.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 180.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 184.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 194.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 199.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 203.8,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 208.55,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 213.3,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.69,
    y: 218.05,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 120.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 125.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 130.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 134.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 139.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 144.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 149.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 153.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 158.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 163.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 196.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 201.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 210.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 106.36,
    y: 220.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 120.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 125.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 130.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 134.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 139.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 144.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 149.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 153.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 158.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 196.64,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 201.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 210.89,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 220.39,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 101.86,
    y: 225.14,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "436.98 319.05 436.98 272.27 432.98 272.27 432.98 249.98 427.13 249.98 427.13 172.48 418.68 172.48 418.68 162.48 400.63 154.06 400.63 143.98 398.13 143.98 398.13 172.48 394.63 172.48 394.63 249.98 391.13 249.98 391.13 209.23 381.63 209.23 381.63 188.23 378.98 188.23 378.98 249.98 371.76 249.98 371.76 226.48 367.01 226.48 367.01 220.48 356.01 220.48 356.01 199.98 349.99 199.98 349.99 185.48 342.59 185.48 342.59 164.35 339.94 164.35 339.94 185.48 332.54 185.48 332.54 199.98 326.51 199.98 326.51 220.48 315.51 220.48 315.51 226.48 310.76 226.48 310.76 249.98 305.13 249.98 305.13 220.48 294.13 220.48 294.13 156.98 290.63 156.98 290.63 149.98 267.13 149.98 267.13 156.98 262.13 156.98 262.13 202.98 242.13 202.98 242.13 207.48 234.63 207.48 234.63 210.98 242.13 210.98 242.13 228.98 221.13 228.98 221.13 168.98 216.63 168.98 216.63 156.23 206.88 156.23 206.88 110.98 204.13 110.98 204.13 156.23 197.13 156.23 197.13 168.98 156.09 168.98 156.09 164.78 153.59 164.78 153.59 193.28 150.09 193.28 150.09 193.78 147.99 193.78 147.99 222.28 144.49 222.28 144.49 230.03 137.09 230.03 137.09 209.03 134.44 209.03 134.44 259.03 131.49 259.03 131.49 238.03 128.84 238.03 128.84 270.78 127.23 270.78 127.23 247.28 122.48 247.28 122.48 241.28 111.48 241.28 111.48 220.78 105.45 220.78 105.45 206.28 98.05 206.28 98.05 185.16 95.41 185.16 95.41 206.28 88 206.28 88 220.78 81.98 220.78 81.98 241.28 70.98 241.28 70.98 247.28 66.23 247.28 66.23 270.28 65.37 270.28 65.37 270.78 63.02 270.78 63.02 319.05 436.98 319.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 183.49,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 187.99,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 192.49,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 196.99,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 201.49,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 205.99,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 210.49,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 171.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 176.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 181.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 186.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 190.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 195.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 200.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 205.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 214.99,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 265.66,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.16,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 274.66,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.16,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 202.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 283.66,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 159.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 164.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 168.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 202.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 288.16,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 328.99,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.49,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 337.99,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 342.49,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 270.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 346.99,
    y: 274.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 270.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 274.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 351.49,
    y: 279.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 260.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 265.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 270.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 274.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 398.66,
    y: 279.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 403.16,
    y: 260.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 407.66,
    y: 260.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.16,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 416.66,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 175.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 179.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 184.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 189.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 194.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 198.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 203.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 208.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 421.16,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 262.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 295.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.49,
    y: 300.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 262.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 94.99,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 209.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 214.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 219.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 224.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 228.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 262.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.49,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 244.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 249.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 253.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 258.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 263.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 268.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 272.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 277.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 282.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 287.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 291.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 296.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 73.66,
    y: 301.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 244.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 249.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 253.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 258.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 263.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 268.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 272.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 277.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 282.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 287.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 291.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 296.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78.16,
    y: 301.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 244.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 249.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 253.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 258.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 263.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 268.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 272.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 277.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 282.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 287.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 291.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 296.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 301.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 82.66,
    y: 306.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 245.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 250.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 255.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 260.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 264.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 269.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 274.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 279.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 283.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 288.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.66,
    y: 302.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 245.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 250.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 255.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 260.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 264.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 269.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 274.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 279.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 283.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 298.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 112.16,
    y: 302.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 245.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 250.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 255.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 260.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 264.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 269.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 274.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 279.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 293.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 298.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 116.66,
    y: 302.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 202.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 249.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 263.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 268.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 273.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.49,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 202.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 273.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 162.99,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 173.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 178.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 183.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 187.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 192.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 197.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 202.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 263.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 268.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 167.49,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 262.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 295.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 300.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 142.16,
    y: 304.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 295.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 300.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.66,
    y: 304.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 233.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 238.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 243.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 247.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 252.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 257.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 266.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 271.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 276.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 281.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 285.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 290.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 295.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 300.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 151.16,
    y: 304.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 249.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 263.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 273.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 282.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 287.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 297.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 301.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 245.99,
    y: 306.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 249.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 263.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 282.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 292.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 297.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 301.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.49,
    y: 306.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 206.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 211.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 216.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 221.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 225.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 230.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 235.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 240.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 244.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 249.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 254.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 259.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 263.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 268.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 278.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 287.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 292.45,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 297.2,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 301.95,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 254.99,
    y: 306.7,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 234.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 238.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 243.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 248.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 253.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 257.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 272.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 276.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 281.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 286.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 291.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 295.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 227.66,
    y: 300.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 234.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 238.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 243.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 248.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 253.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 257.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 272.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 276.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 281.53,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 286.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 291.03,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 295.78,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.16,
    y: 305.28,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 260.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 270.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 274.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 279.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 284.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 289.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 293.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 298.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.66,
    y: 303.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 213.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 217.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 222.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 227.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 232.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 236.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 241.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 246.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 251.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 255.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 260.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 265.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 270.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 274.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 279.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 284.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 289.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 293.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 298.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 386.16,
    y: 303.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 231.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 236.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 241.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 245.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 250.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 255.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 260.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 264.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 269.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 359.49,
    y: 274.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 231.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 236.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 241.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 245.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 250.62,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 255.37,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 260.12,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 264.87,
    width: 2.83,
    height: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 363.99,
    y: 269.62,
    width: 2.83,
    height: 2.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 319.05,
    width: 500,
    height: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-9",
    cx: 250,
    cy: 352.64,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Darker_line",
    "data-name": "Darker line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.69,292a.76.76,0,0,1-.71-.51.75.75,0,0,1,.46-1c1.11-.39,110.63-39.28,104.31-79.93-3-19.14-73.86-16.93-148.9-14.6-86.91,2.71-176.79,5.5-192.34-21.53-4.32-7.5-4.28-15.86.1-24.84C92.24,119.68,149.49,91.25,182.31,77,232.75,55,291.48,37.52,335.57,31.31a.75.75,0,0,1,.21,1.49c-44,6.19-102.54,23.64-152.87,45.55C127.38,102.51,89.49,128.73,79,150.28c-4.15,8.51-4.2,16.39-.15,23.43,15.1,26.26,108.55,23.35,191,20.78,79-2.45,147.24-4.58,150.42,15.87C423,228,406,247.13,369.89,267.16a409.83,409.83,0,0,1-54.95,24.78A1.09,1.09,0,0,1,314.69,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M314.69,292a.76.76,0,0,1-.71-.51.75.75,0,0,1,.46-1c1.11-.39,110.63-39.28,104.31-79.93-3-19.14-73.86-16.93-148.9-14.6-86.91,2.71-176.79,5.5-192.34-21.53-4.32-7.5-4.28-15.86.1-24.84C92.24,119.68,149.49,91.25,182.31,77,232.75,55,291.48,37.52,335.57,31.31a.75.75,0,0,1,.21,1.49c-44,6.19-102.54,23.64-152.87,45.55C127.38,102.51,89.49,128.73,79,150.28c-4.15,8.51-4.2,16.39-.15,23.43,15.1,26.26,108.55,23.35,191,20.78,79-2.45,147.24-4.58,150.42,15.87C423,228,406,247.13,369.89,267.16a409.83,409.83,0,0,1-54.95,24.78A1.09,1.09,0,0,1,314.69,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M78.16,174.83a.75.75,0,0,1-.65-.37c-4.32-7.5-4.28-15.86.1-24.84C92.24,119.68,149.49,91.25,182.31,77,232.75,55,291.48,37.52,335.57,31.31a.75.75,0,0,1,.21,1.49c-44,6.19-102.54,23.64-152.87,45.55C127.38,102.51,89.49,128.73,79,150.28c-4.15,8.5-4.2,16.39-.15,23.43a.75.75,0,0,1-.28,1A.74.74,0,0,1,78.16,174.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M314.69,292a.76.76,0,0,1-.71-.51.75.75,0,0,1,.46-1c1.11-.39,110.63-39.28,104.31-79.93a.75.75,0,0,1,1.48-.23C423,228,406,247.13,369.89,267.16a409.83,409.83,0,0,1-54.95,24.78A1.09,1.09,0,0,1,314.69,292Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M296.18,121.9l.31-7.73s2.07-2,2.07-3.38-2.38-8.94-3.42-9.3-6.63,2.29-6.73,4,2.9,8,3.42,8.46l-.83,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M380.41,111.23l-2.66-7.65a21.52,21.52,0,0,1-3.14-2.74c-.73-1,3.34-8.21,3.94-8.21A21,21,0,0,1,384,95.69c.6.72-2.58,6.6-2.58,6.6l3.95,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M364.94,109.94c3.67.36,21.3,19.21,21.3,19.21L378.63,108l6-2.05s14.86,23.67,11.6,32.37-32.37-11.24-32.37-11.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "308.52 334.89 304.41 329.51 311.37 322.8 317.7 316.7 323.65 322.26 315.65 328.94 308.52 334.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M304.17,327.87c.61-.43,5.7,7.2,5.7,7.2s-1.13,8,1.17,13.09-2.17,4.7-5.89-.16L296,336C293.33,332.51,297.92,332.42,304.17,327.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.79,336.55s3.41-1.1,3.81.74c.45,2.12-3.81-.74-3.81-.74s3.44,2.57,2.53,3.72C310.94,342,309.79,336.55,309.79,336.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "315.65 328.94 311.37 322.8 317.7 316.7 323.65 322.26 315.65 328.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "349.65 343.4 342.88 343.4 341.77 333.98 340.77 325.34 348.8 324.03 349.25 334.29 349.65 343.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M341.43,343c0-.75,9.18-.16,9.18-.16s5.64,5.73,11.11,7,2.42,4.57-3.7,4.57H342.88C338.53,354.4,341.25,350.7,341.43,343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M351.74,343.77s1.2-3.38,2.9-2.57c2,.92-2.9,2.57-2.9,2.57s4.13-1.18,4.49.24C356.78,346.17,351.74,343.77,351.74,343.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "349.25 334.5 341.77 334.17 340.77 325.43 348.8 324.08 349.25 334.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.53,180.66s20,47.25,23.13,68S321.8,325,321.8,325l-7.26-7.72s52.82-54.3,52.82-63.64-20.6-52-20.6-52S344.77,184.39,366.53,180.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M352.06,299.1c-7.25,6.68-14.27,12.71-19.72,17.27C326,321.65,321.8,325,321.8,325l-7.26-7.72s7.26-7.45,16.38-17.32c7.18-7.75,15.53-17,22.42-25.28,8-9.6,14-17.89,14-21,0-4.92-5.73-19.11-11.14-31.43-4.86-11-9.46-20.57-9.46-20.57a17.63,17.63,0,0,1,.57-5.84c1.39-5.35,5.78-12.78,19.21-15.09,0,0,20,47.25,23.12,68C391.38,260,370.94,281.72,352.06,299.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M353.34,274.63l-1.28,24.47c-7.25,6.68-14.27,12.71-19.72,17.27a58.25,58.25,0,0,1-1.42-16.46C338.1,292.16,346.45,282.91,353.34,274.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M356.22,222.16c-4.86-11-9.46-20.57-9.46-20.57a17.63,17.63,0,0,1,.57-5.84,6.91,6.91,0,0,1,2.27-.95S355.51,204.08,356.22,222.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M330.51,72.22s6.07-7.57,16-5.88,8.17,20.09,8.17,20.09A13.28,13.28,0,0,1,359,99.57c-1.94,8.32-24.59,13.14-33.25,7.35s-2-24.16,2.21-26.76S330.51,72.22,330.51,72.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.79,194.8,351,261.32V329.4H339.67c-27.06-129-8.51-161.34-8.51-161.34l.07,0c0-.05,0-.11.06-.15,4.35-9.66,32.85-2.54,32.85-2.54,2.05,8,3.31,24.27,3.31,24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M349.79,194.8,351,261.32V329.4H339.67c-27.06-129-8.51-161.34-8.51-161.34l.07,0c0-.05,0-.11.06-.15,4.35-9.66,32.85-2.54,32.85-2.54,2.05,8,3.31,24.27,3.31,24.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "331 163.09 331 167.92 364 165.39 364 159.67 331 163.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 340.65,
    y: 161.09,
    width: 1.64,
    height: 8.35,
    transform: "translate(-7.99 17.63) rotate(-2.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 349.39,
    y: 161.16,
    width: 7.24,
    height: 5.49,
    transform: "translate(-13.21 32.14) rotate(-5.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 360.81,
    y: 158.88,
    width: 1.64,
    height: 8.35,
    transform: "translate(-7.84 18.64) rotate(-2.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 340.65,
    y: 161.09,
    width: 1.64,
    height: 8.35,
    transform: "translate(-7.99 17.63) rotate(-2.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 360.81,
    y: 158.88,
    width: 1.64,
    height: 8.35,
    transform: "translate(-7.84 18.64) rotate(-2.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M364.14,160.25l-33,2.85c-.78-12.27-1.56-20.18-8.83-42-.63-1.91-1.31-3.94-2.06-6.08a98,98,0,0,1,13.7-3.31,105.2,105.2,0,0,1,14.82-1.56c6.42,0,13.8.67,13.8.67s1.05.25,1.71,7.06C364.87,124.22,365.46,137,364.14,160.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M364.14,160.25l-33,2.85c-.78-12.27-1.56-20.18-8.83-42-.63-1.91-1.31-3.94-2.06-6.08a98,98,0,0,1,13.7-3.31,105.2,105.2,0,0,1,14.82-1.56c6.42,0,13.8.67,13.8.67s1.05.25,1.71,7.06C364.87,124.22,365.46,137,364.14,160.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M346,117.39c-8.14-1-10.58-4.52-10.58-4.52,5.16-4.87.87-13.3.87-13.3l9.79,1.82a27.67,27.67,0,0,0-.38,4.13c-.08,5.94,2.61,6,2.61,6C350.07,114.74,346,117.39,346,117.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M346.12,101.39a27.67,27.67,0,0,0-.38,4.13c-4.72-1.1-9.41-6-9.41-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.39,74.29c8.3-2,12,1.85,14.65,10.25,3.29,10.5,2.72,18.65-8.19,18.83C329,103.61,323.62,77.56,337.39,74.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346.57,85.35a18.12,18.12,0,0,0,3.23,2.87,2.33,2.33,0,0,1-2,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M341.33,85.87c.18.68,0,1.33-.49,1.44s-1-.33-1.14-1,0-1.32.49-1.44S341.16,85.2,341.33,85.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M340,84.94l1.33-1S340.93,85.41,340,84.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M349.72,83.53c.18.67-.05,1.32-.5,1.44s-1-.34-1.14-1,.05-1.32.5-1.44S349.54,82.85,349.72,83.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M348.4,82.6l1.32-1S349.31,83.06,348.4,82.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M339.89,80.16a4.44,4.44,0,0,0-3.3,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M345.84,78.39a4,4,0,0,1,3.47-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M347.4,93.22a22.33,22.33,0,0,0-.29,3.11l-.54.08c-2.47.33-3.73-.34-4.37-1.17a3.31,3.31,0,0,1-.59-1.41,3.09,3.09,0,0,1,0-.87,11.74,11.74,0,0,0,5,.36C347.07,93.28,347.4,93.22,347.4,93.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.55,93.32l-.1.92c-2.33.3-4,.2-4.84-.41a3.09,3.09,0,0,1,0-.87A11.74,11.74,0,0,0,346.55,93.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M346.57,96.41c-2.47.33-3.73-.34-4.37-1.17a8,8,0,0,1,2.82.18A3,3,0,0,1,346.57,96.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.64,90.42s2.26-7.73.43-12.85c0,0,14.84-10.61,19.61,5.88,0,0-1.9-15.2-16.24-12.15s-9.33,23.9-.5,28.37C334.94,99.67,330.25,95.25,331.64,90.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.41,91.85a3.74,3.74,0,0,0-4.7-2.39c-2.51.89-2.48,6.45,4.21,6.21C333.88,95.63,334.19,94.61,333.41,91.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M364.27,117.83c-12.4,6.13-31.4,4.7-42,3.22-.63-1.91-1.31-3.94-2.06-6.08a98,98,0,0,1,13.7-3.31,105.2,105.2,0,0,1,14.82-1.56c6.42,0,13.8.67,13.8.67S363.61,111,364.27,117.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M327.17,111.63s8.89,11.36,9.16,23.68-7.94,69.08-7.94,69.08l-9.9-2.8s7.48-43.7,0-85.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M354.72,110.4s3.62,11.77,3.14,20.23,8.67,50.11,8.67,50.11l2.66,6.4-2.63-25.83s1.59-37.91-1.62-50.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.39,74.29s3.07,10.45-6.28,15.18c-11.3,5.72-10.22,18.08.8,19.65,0,0-11.13-1.12-13.29-8.39s4-18.46,4-18.46-3.38-6.15,5.75-11C333.49,68.57,337.39,74.29,337.39,74.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "338.21 327.77 352.37 325.69 351.19 331.35 339.5 332.93 338.21 327.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "314.54 314.62 324.04 324.95 319.29 327.67 311.96 319.89 314.54 314.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M370.82,87.76c-1.71-3.06-5-4.46-7.42-3.12s-2.93,4.89-1.23,8,5,4.45,7.42,3.12S372.53,90.81,370.82,87.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M390.23,77l-5.88-10.81s-4.1,8.81-10,12.11l3,5.36.47.84,3,5.37c5.9-3.31,15.55-2.19,15.55-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M370.82,87.76c-1.71-3.06-5-4.46-7.42-3.12s-2.93,4.89-1.23,8,5,4.45,7.42,3.12S372.53,90.81,370.82,87.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M390.23,77l-5.88-10.81s-4.1,8.81-10,12.11l3,5.36.47.84,3,5.37c5.9-3.31,15.55-2.19,15.55-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M370.42,94.09s4.25,6.15,8.22,8.4a.65.65,0,0,0,.83-.17l3.39-4.2a.67.67,0,0,0-.25-1c-1.67-.74-5.57-2.64-7.82-5.3C371.87,88.34,370.42,94.09,370.42,94.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M370.42,94.09s4.25,6.15,8.22,8.4a.65.65,0,0,0,.83-.17l3.39-4.2a.67.67,0,0,0-.25-1c-1.67-.74-5.57-2.64-7.82-5.3C371.87,88.34,370.42,94.09,370.42,94.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M396.3,88c-1.35.75-5.19-3.54-8.57-9.58s-5-11.57-3.67-12.33,5.19,3.54,8.57,9.59S397.66,87.27,396.3,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M395.75,86.24c-1,.57-4-2.81-6.83-7.66-.16-.27-.32-.56-.48-.85s-.38-.68-.56-1C385.29,71.82,384,67.6,385,67s4.37,3.21,7.33,8.51S396.83,85.64,395.75,86.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M369,96.83s-1.45-1-4.08-5.74c-2.85-5.09-2.77-6.52-2.77-6.52l13.17-7.37s.16,1.85,2.83,6.63,4,5.63,4,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.92,78.58c-.16-.27-.32-.56-.48-.85s-.38-.68-.56-1l1.36-.43a.62.62,0,0,1,.75.34l.11.2a.61.61,0,0,1-.1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M388.92,78.58c-.16-.27-.32-.56-.48-.85s-.38-.68-.56-1l1.36-.43a.62.62,0,0,1,.75.34l.11.2a.61.61,0,0,1-.1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M318.49,115.68c-4.59,2-21,31.3-21,31.3l-.32-27.7-7.41-1s-4.51,39.29,5.15,41.54,27.38-25.76,27.38-25.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M336.33,73.05s4.25,3.07,1.09,11.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M353.81,85.75s11.69,7.57,4.11,17.32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 105.57,
    y: 14.28,
    width: 188.74,
    height: 339.47,
    rx: 10.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288,25.66V341.78a4.62,4.62,0,0,1-4.69,4.62H116.19a4.14,4.14,0,0,1-4.19-4.24V25.28a3.73,3.73,0,0,1,3.59-3.88h41.78a2.94,2.94,0,0,1,2.69,1.88l1.73,4.26a2.94,2.94,0,0,0,2.69,1.86h71.13a2.91,2.91,0,0,0,2.69-1.83L240,23.29a3,3,0,0,1,2.69-1.89H283.9A4.22,4.22,0,0,1,288,25.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 112,
    y: 41.9,
    width: 176,
    height: 39.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 131.85,
    y: 31.24,
    width: 2.17,
    height: 2.9,
    transform: "translate(265.87 65.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 128.3,
    y: 30.27,
    width: 2.17,
    height: 3.87,
    transform: "translate(258.78 64.41) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 124.76,
    y: 29.3,
    width: 2.17,
    height: 4.83,
    transform: "translate(251.7 63.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 121.22,
    y: 28.34,
    width: 2.17,
    height: 5.8,
    transform: "translate(244.61 62.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 267.25,
    y: 30.18,
    width: 1.29,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 269.42,
    y: 29.12,
    width: 10.27,
    height: 5.01,
    transform: "translate(549.1 63.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 196.01,
    cy: 21.81,
    r: 2.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M203.32,21.81a1.55,1.55,0,1,1-1.55-1.54A1.55,1.55,0,0,1,203.32,21.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288,286.4v55.38a4.62,4.62,0,0,1-4.69,4.62H116.19a4.14,4.14,0,0,1-4.19-4.24V286.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "131.33 180.61 199.94 122.96 268.54 180.61 214.75 252.76 166.44 251.79 131.33 180.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "131.33 180.61 199.94 122.96 268.54 180.61 214.75 252.76 166.44 251.79 131.33 180.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 151.14,
    y: 103.96,
    width: 97.59,
    height: 142.68,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 116.85,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 126.51,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 136.18,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 145.85,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 155.52,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 165.19,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 174.86,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 184.52,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 161.53,
    y: 194.19,
    width: 76.82,
    height: 2.9,
    rx: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M203.61,230.89l-.38-.21a4.55,4.55,0,0,0-4.45,0l-1.85,1.05L131,180.61V265a4.43,4.43,0,0,0,4.52,4.41H264.36c2.48,0,3.64-1.91,3.64-4.41V180.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M203.61,230.89l-.38-.21a4.55,4.55,0,0,0-4.45,0l-1.85,1.05L131,180.61V265a4.43,4.43,0,0,0,4.52,4.41H264.36c2.48,0,3.64-1.91,3.64-4.41V180.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "193.95 229.44 196.93 231.75 150.34 258.2 193.95 229.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "254.5 259.2 203.54 230.94 205.89 229.1 254.5 259.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 173,
    y: 48.07,
    width: 57.33,
    height: 5.33,
    rx: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.67,76.07H250a3.33,3.33,0,0,1-3.33-3.34h0A3.33,3.33,0,0,1,250,69.4h25.67A3.33,3.33,0,0,1,279,72.73h0A3.33,3.33,0,0,1,275.67,76.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 124.67,
    y: 294.73,
    width: 25.67,
    height: 24.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 155.89,
    y: 294.73,
    width: 25.67,
    height: 24.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 187.12,
    y: 294.73,
    width: 25.67,
    height: 24.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 218.35,
    y: 294.73,
    width: 25.67,
    height: 24.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 249.57,
    y: 294.73,
    width: 25.67,
    height: 24.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.67,336.23H250a3.33,3.33,0,0,1-3.33-3.33h0a3.34,3.34,0,0,1,3.33-3.34h25.67A3.34,3.34,0,0,1,279,332.9h0A3.33,3.33,0,0,1,275.67,336.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "270.39 14.4 106 248.32 106 144.69 197.48 14.4 270.39 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M174.86,14.4,106,112.74v-88A9.94,9.94,0,0,1,116,14.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bright_line",
    "data-name": "Bright line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.16,174.83a.75.75,0,0,1-.65-.37c-4.32-7.5-4.28-15.86.1-24.84C92.24,119.68,149.49,91.25,182.31,77,232.75,55,291.48,37.52,335.57,31.31a.75.75,0,0,1,.21,1.49c-44,6.19-102.54,23.64-152.87,45.55C127.38,102.51,89.49,128.73,79,150.28c-4.15,8.5-4.2,16.39-.15,23.43a.75.75,0,0,1-.28,1A.74.74,0,0,1,78.16,174.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.69,292a.76.76,0,0,1-.71-.51.75.75,0,0,1,.46-1c1.11-.39,110.63-39.28,104.31-79.93a.75.75,0,0,1,1.48-.23C423,228,406,247.13,369.89,267.16a409.83,409.83,0,0,1-54.95,24.78A1.09,1.09,0,0,1,314.69,292Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.13cd2223f69cbb2d87a50f0b6edda67a.svg";
export { ForwardRef as ReactComponent };